import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {SecurityMasterService} from '../security-master/security-master.service';
import {IViewOption} from '../irb-models.model';
import {formatDate} from '@angular/common';

@Component({ standalone: false,
    selector: 'irb-view-option',
    templateUrl: './view-option.component.html',
    styleUrls: ['./view-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ViewOptionComponent implements OnInit {

    viewOptionList: Array<IViewOption>;
    gridOptions: any;
    params: any;
    securitySymbol: string;
    defaultGridHeights:any = {
        height: '350px',
        domLayout:'normal'
    };
    isUiTest = false;
    constructor(public dialogRef: MatDialogRef<ViewOptionComponent>,
                @Inject(MAT_DIALOG_DATA) public mdd: any,
                private readonly securityMasterService: SecurityMasterService) {
    }

    ngOnInit(): void {
        this.gridOptions = {
            columnDefs: this.getColumnDefs(),
            floatingFilter: false
        }
    }

    onGridReady(params: any) {
        this.params = params;
        this.securitySymbol = this.mdd.data.securitySymbol;
        this.getViewOption();
    }

    close() {
        this.dialogRef.close();
    }

    formatCreatedDate(params: any) {
        return formatDate(params.data.expirationDate, 'MM/dd/yyyy', 'en-US', 'ET');
    }

    getColumnDefs() {
        return [
            {
                headerName: 'Symbol',
                field: 'symbol',
                minWidth: 195,
                width: 195
            },
            {
                headerName: 'Description',
                field: 'description',
                cellRenderer: 'cellRendererFormatter',
                minWidth: 220,
                width: 220
            },
            {
                headerName: 'Strike Price',
                field: 'strikePrice',
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: {type: 'currency', decimalPosition: '2'},
                minWidth: 114,
                width: 108
            },
            {
                headerName: 'Type',
                field: 'type',
                minWidth: 60,
                width: 68
            },
            {
                headerName: 'Expiration Date',
                field: 'expirationDate',
                valueFormatter: this.formatCreatedDate,
                minWidth: 138,
                width: 138
            }]
    }

    getViewOption() {
        let securityId = null;

        if (this.mdd && this.mdd.data && this.mdd.data.securityId) {
            securityId = this.mdd.data.securityId;
        }            

        if (!securityId) {
            this.params.api.setGridOption('rowData', []);
            return;
        }

        this.securityMasterService.getOptionView(securityId).subscribe((res: IViewOption[]) => {
            this.viewOptionList = res;
            this.params.api.setGridOption('rowData', this.viewOptionList);
            this.params.api.applyColumnState({state: [{colId: 'expirationDate', sort: 'asc'}]});
            if(this.viewOptionList.length <= 12 ) {
                this.defaultGridHeights = {
                    height: null,
                    domLayout:'autoHeight'
                };
            } else {
                this.defaultGridHeights ={
                    height: '350px',
                    domLayout:'normal'
                };
            }
            this.params.api.setGridOption('domLayout', this.defaultGridHeights.domLayout);
            //this.params.api.sizeColumnsToFit();
        });
    }
}
